import {BUS_REVIEW_URL,PROMO_URL,TENTATIVE_URL,REVIEW_GOSAFE_URL,REVIEW_SOCIAL_DISTANCE_URL,BUS_REVIEW_DEPOT_URL, BUS_PROMO_DISCOUNT_URL, BUS_SUBMIT_URL} from '../../config/apiPoints';
import {IBUS_REVIW_API_DATA_FETCH} from './Validation';

export const prepareReviewApiRequest = (params: IBUS_REVIW_API_DATA_FETCH) => {
  const {bookingKey,querydata,token,page_source} = params;
  const query = `?flavour=v2&booking-key=${bookingKey}&p=native${
  token
      ? `&vc=v2&token=${token}&qry=${encodeURIComponent(querydata)}`
      : '&vc=v4'
  }${page_source ? `&page_src=${page_source}`:''}`;
  let url = `${__ENV_CONFIG__.__GOIBIBO__}${BUS_REVIEW_URL}${query}`;
  
  return url;
};

export const preparePromoDiscountApiRequest =()=>{
  const url = `${__ENV_CONFIG__.__GOIBIBO__}${BUS_PROMO_DISCOUNT_URL}`;
  return url;
}
export const prepareTentativeAPIReqURL = ()=>{
  const url = `${__ENV_CONFIG__.__GOIBIBO__}${BUS_SUBMIT_URL}`
  return url;
}
export const prepareGoSafeUrl = ()=>{
  const url = `${__ENV_CONFIG__.__VOYAGER__}${REVIEW_GOSAFE_URL}`;
  return url;
}
export const prepareSocialDistanceUrl=()=>{
  const url = `${__ENV_CONFIG__.__VOYAGER__}${REVIEW_SOCIAL_DISTANCE_URL}`;
  return url;
  
}